import React from "react";
import { Filter } from "@common/filter";
import { ProjectPortfolio } from "./projectPortfolio";
import { Props } from "./types";
import styles from "./styles.scss";

function ProjectPortfolios({
  projectPortfolios,
  filter,
  columnSizes,
  resizeCol,
  resizeDone,
}: Props) {
  return (
    <Filter
      filter={filter}
      data={projectPortfolios}
      extractCriteria={(projectPortfolio) => ({ projectPortfolio })}
    >
      {(filtered) => (
        <ul className={styles.projectPortfolios}>
          {[...filtered].reverse().map((projectPortfolio) => (
            <li key={projectPortfolio.uuid} className={styles.projectPortfolio}>
              <ProjectPortfolio
                projectPortfolio={projectPortfolio}
                filter={filter}
                columnSizes={columnSizes}
                resizeCol={resizeCol}
                resizeDone={resizeDone}
              />
            </li>
          ))}
        </ul>
      )}
    </Filter>
  );
}

export { ProjectPortfolios };
